@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.favoritepoints
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object DeleteFavoritePointEndpoint :
    EndPoint<DeleteFavoritePointEndpoint.Request, DeleteFavoritePointEndpoint.Response>() {
    class Request(
        val favoritePointId: KmmLong
    )

    class Response()
}